import { render } from "./JsonCSV.vue?vue&type=template&id=3999be9d&scoped=true&ts=true"
import script from "./JsonCSV.vue?vue&type=script&lang=ts"
export * from "./JsonCSV.vue?vue&type=script&lang=ts"

import "./JsonCSV.vue?vue&type=style&index=0&id=3999be9d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-json-csv/vue-json-csv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3999be9d"]])

export default __exports__